// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-79aeeec3]{border-collapse:collapse}table[data-v-79aeeec3],td[data-v-79aeeec3],th[data-v-79aeeec3]{border:.5px solid #000}thead[data-v-79aeeec3]{display:table-row-group}tr td[data-v-79aeeec3]{page-break-inside:avoid}.no-border[data-v-79aeeec3]{border:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
